module.exports = __webpack_public_path__ + "img/homebg_5.92158888.png";